module.exports = __webpack_public_path__ + "img/img_result-stand-02.12f54987.png";